<template>
  <div class='sld_collect_index wd'>
    <!-- 会员基本信息 -->
    <div class="user_info_top">
      <div class="user_info_l fl">

        <div class="user_avatar sld_img_center">
          <img :src="memberInfo.info.memberAvatar" class="head_img">
        </div>
        <img :src="grade.data.gradeLogo" alt="" v-if="grade.data.gradeLogo" class="gradeLogo_img_index">
        <div class="user_avatar_r">
          <b>{{memberInfo.info.memberNickName}} {{memberInfo.info.memberName}}</b>
        </div>

        <router-link :to="'/member/address/list'" class="user_addr" target="_blank"><span class="fl"><i
              class="iconfont">&#xe70f;</i>{{L['会员收货地址']}}</span>
          <i class="fr iconfont">&#xe616;</i>
        </router-link>
      </div>
      <div class="infoCon clearfix">
        <div class="info_rcol">
          <h4 class="user_title"><i class="iconfont">&#xe608;</i>{{L["我的财产"]}}</h4>
          <ul class="acco_info fl">
            <li class="acco_item">
              <div>
                <em ref="balance" id="balance">￥ <span id="balanceTitle">{{memberInfo.info.memberBalance}}</span></em>
                <p  v-if="store.state.memberInfo.multipleStoresId > 0">{{L['合并余额']}}</p>
                <p v-else>{{L['余额']}}</p>
                <a class="sld_link" @click="showMemberList" v-if="store.state.memberInfo.multipleStoresId > 0">{{L['所有门店']}}</a>
                <router-link class="sld_link" :to="'/member/combinedBalance'" target="_blank"  v-if="store.state.memberInfo.multipleStoresId > 0">{{L['明细']}}</router-link>
                <router-link class="sld_link" :to="'/member/recharge'" target="_blank">{{L['充值']}}</router-link>
              </div>
            </li>
            <li class="acco_item">
              <div>
                <!-- <em ref="balance" id="balance">￥ <span id="balanceTitle">{{memberInfo.info.pzye}}</span></em> -->
                <em ref="balance" id="balance">￥ <span id="balanceTitle">{{Number(balance_info).toFixed(2)}}</span></em>
                <p>{{L['票折余额']}}</p>
                <router-link class="sld_link" :to="'/member/bookBalance'" target="_blank">{{'明细'}}</router-link>
              </div>
            </li>
            <li class="acco_item">
              <div>
                <a class="sld_red_num">{{memberInfo.info.couponNum}}</a>
                <p>{{L['优惠券']}}</p>
                <router-link class="sld_link" :to="'/coupon'" target="_blank">{{L['领券']}}</router-link>
              </div>
            </li>
            <li class="acco_item">
              <div>
                <em>{{memberInfo.info.memberIntegral}}</em>
                <p>{{L['积分']}}</p>
                <router-link class="sld_link" :to="'/member/myPoint'" target="_blank">{{L['查看']}}</router-link>
              </div>
            </li>
            <!-- <li class="acco_item">
              <div>
                <em>{{memberInfo.info.followStoreNum}}</em>
                <p>{{L['店铺关注']}}</p>
                <router-link class="sld_link" :to="'/member/collect?type=store'" target="_blank">{{L['查看']}}
                </router-link>
              </div>
            </li> -->
          </ul>
        </div>
      </div>
    </div>
    <!-- 门店列表弹窗 -->
    <el-dialog
      v-model="storeListVisible"
      :title="L['多账号组门店清单']"
      width="900px"
      :before-close="handleCloseStoreList"
    >
      <el-table :data="storeList" style="width: 100%">
        <el-table-column prop="companyName" :label="L['门店名称（公司名称）']" width="400" />
        <el-table-column prop="createTime" :label="L['合并时间']" width="250" />
        <el-table-column :label="L['委托书下载']">
          <template #default="scope">
            <a href="javascript:void(0)" @click="handleDownload(scope.row.attachmentId)">
              委托书下载链接
            </a>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 会员订单信息 -->
    <div class="user_order clearfix">
      <div class="my_order fl">
        <h4 class="user_title"><i class="iconfont">&#xe619;</i>{{L['我的订单']}}
          <el-button  v-if="store.state.memberInfo.multipleStoresId !== 0"
                      class="merge-pay-btn"
                      @click="mergePay"
          >
            {{L['合并支付']}}
          </el-button>
        </h4>

        <ul class="clearfix order_state_nav">
          <li>
            <router-link :to="'/member/order/list?orderState=10'" target="_blank">
              <i class="iconfont">&#xe677;</i>
              <p>{{L['待支付']}}</p>
              <div class="tag" v-if="memberInfo.info.toPaidOrder>0">{{memberInfo.info.toPaidOrder}}</div>
            </router-link>

          </li>
          <li>
            <router-link :to="'/member/order/list?orderState=30'" target="_blank">
              <i class="iconfont">&#xe676;</i>
              <p>{{L['待收货']}}</p>
              <div class="tag" v-if="memberInfo.info.toReceivedOrder>0">{{memberInfo.info.toReceivedOrder}}</div>

            </router-link>
          </li>
          <li>
            <router-link :to="'/member/order/list?orderState=40&evaluateState=1'" target="_blank">
              <i class="iconfont">&#xe678;</i>
              <p>{{L['待评价']}}</p>
              <div class="tag" v-if="memberInfo.info.toEvaluateOrder>0">{{memberInfo.info.toEvaluateOrder}}</div>
            </router-link>
          </li>
          <li>
            <router-link :to="'/member/order/aftersales'" target="_blank">

              <i class="iconfont">&#xe67c;</i>
              <p>{{L['售后/退货']}}</p>
              <div class="tag" v-if="memberInfo.info.afterSaleNum>0">{{memberInfo.info.afterSaleNum}}</div>
            </router-link>
          </li>
          <li>
            <router-link :to="'/member/order/list'" target="_blank">
              <span>
                <i class="iconfont">&#xe634;</i>
              </span>
              <p>{{L['全部订单']}}</p>
            </router-link>
          </li>
        </ul>
        <div v-if="order.list.length>0">
          <div class="user-order-item clearfix"
            v-for="({createTime,totalMoney,orderProductListVOList,orderSn,orderStateValue,orderState,sendOutGoods},index) in order.list"
            :key="index">
            <div class="fl">
              <router-link class="fl img" :to="`/goods/detail?productId=${orderProductListVOList[0].productId}`"
                target="_blank">
                <!-- <img :src="orderProductListVOList[0].productImage" alt=""> -->
                <coverImage :src="orderProductListVOList[0].productImage" class="img"></coverImage>
              </router-link>
              <a class="fl">
                <p>{{orderProductListVOList[0].goodsName}}</p>
                <p class="price">￥{{totalMoney}}</p>
                <p class="time">下单时间:{{createTime}}</p>
              </a>
            </div>
            <div class="fr">
              <p class="orderSn">订单号:{{orderSn}}</p>
              <p class="orderState">{{orderState==20 && sendOutGoods==1 ? '已出库' : orderStateValue}}</p>
              <a @click="seeOrderDetail(orderSn)" style="cursor: pointer">{{L['查看详情']}}</a>
            </div>
          </div>
        </div>
        <div class="user_order_empty flex_row_center_center" v-else>
          <img src="@/assets/member/member_empty.png" alt="">
          <p>{{L['这里空空如也，快去挑选合适的商品吧~']}}</p>
        </div>
      </div>
      <div class="my_follow fr">

        <!-- 购物车item -->
        <div class="my_follow_item cartItem">
          <h4 class="user_title"><i class="iconfont icon-gouwuche"></i>{{L['购物车']}} ({{cartLen}})<router-link
              :to="'/cart/index'" target="_blank">{{L['查看更多']}}></router-link>
          </h4>
          <ul class="clearfix">
            <template v-for="(storeItem,storeIndex) in cartData.data.storeCartGroupList" :key="storeIndex">
              <template v-for="(promotItem,promotIndex) in storeItem.promotionCartGroupList" :key="promotIndex">
                <li class="list_item" v-for="(cartItem,cartIndex) in promotItem.cartList" :key="cartIndex">
                  <a @click="toProductDetail(cartItem.productId)">
                    <img :src="cartItem.productImage" alt="">
                  </a>
                </li>
              </template>
            </template>
            <div class="no_footprint" v-show="!cartLen">暂无商品~</div>
          </ul>
        </div>

        <!-- 关注店铺item -->
        <div class="my_follow_item store">
          <h4 class="user_title"><i class="iconfont">&#xe679;</i>{{L['店铺关注']}} ({{memberInfo.info.followStoreNum}})
            <router-link :to="'/member/collect?type=store'" target="_blank">{{L['查看更多']}}></router-link>
          </h4>
          <ul class="clearfix">
            <li class="list_item" v-for="({storeLogo,storeId},index) in collectStore.store" :key="index">
              <router-link :to="`/store/index?vid=${storeId}`" target="_blank">
                <img :src="storeLogo" alt="">
              </router-link>
            </li>
            <div class="no_footprint" v-show="!collectStore.store.length">暂无关注店铺~</div>
          </ul>
        </div>

        <!-- 收藏商品item -->
        <div class="my_follow_item goods">
          <h4 class="user_title"><i class="iconfont">&#xe67d;</i>{{L['我的收藏']}} ({{memberInfo.info.followProductNum}})
            <router-link :to="'/member/collect'" target="_blank">{{L['查看更多']}}></router-link>
          </h4>
          <ul class="clearfix">
            <li class="list_item" v-for="({productImage,productId},index) in collectGoods.goods" :key="index">
              <a @click="toProductDetail(productId)">
                <img :src="productImage" alt="">
              </a>
            </li>
            <div class="no_footprint" v-show="!collectGoods.goods.length">暂无收藏商品~</div>
          </ul>
        </div>

        <!-- 足迹item -->
        <div class="my_follow_item footprint">
          <h4 class="user_title"><i class="iconfont">&#xe67f;</i>{{L['我的足迹']}} ({{memberInfo.info.lookLogNum}})
            <router-link :to="'/member/footprint'" target="_blank">{{L['查看更多']}}></router-link>
          </h4>
          <ul class="clearfix">
            <li class="list_item" v-for="({goodsImage,productId},index) in looklog.log" :key="index">
              <a @click="toProductDetail(productId)">
                <img :src="goodsImage" alt="">
              </a>
            </li>
            <div class="no_footprint" v-show="!looklog.log.length">暂无足迹~</div>
          </ul>
        </div>


      </div>
    </div>
    <!-- 热销推荐 -->
    <div class="user_hot_goods clearfix">
      <h3>{{L['热销推荐']}}</h3>
      <ul class="clearfix">
        <li v-for="({goodsImage,goodsName,goodsPrice,defaultProductId},index) in hotRecom.goods" :key="index">
          <a @click="toProductDetail(defaultProductId)">
            <div class="img">
              <img class="lazy" :src="goodsImage" alt="">
            </div>
            <p class="hot_goods_name">{{goodsName}}</p>
            <p class="hot_goods_price">￥<em>{{goodsPrice}}</em></p>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import { reactive, onMounted, getCurrentInstance, ref } from 'vue'
  import { useRouter } from 'vue-router'
  import { useStore } from "vuex";
  import { ElMessage } from 'element-plus';
  import {download} from "@/utils/request";
  export default {
    name: 'index',
    setup() {
      const router = useRouter()
      const store = useStore();
      const memberInfo = reactive({ info: {} })
      const looklog = reactive({ log: [] })
      const looklogLen = ref(0)
      const cartData = reactive({ data: [] })
      const cartLen = ref(0)
      const collectStore = reactive({ store: [] })
      const collectGoods = reactive({ goods: [] })
      const hotRecom = reactive({ goods: [] })
      const order = reactive({ list: [] })
      const { proxy } = getCurrentInstance()
      const grade = reactive({data:{}})
      const L = proxy.$getCurLanguage()
      const balance_info = ref('');

      // 门店列表弹窗相关数据
      const storeListVisible = ref(false);
      const storeList = ref([]);

      const getInitInfo = () => {  //获取会员信息数据
        proxy.$get('/v3/member/front/member/getInfo').then(res => {
          if (res.state == 200) {
            memberInfo.info = res.data
            store.commit("updateMemberInfo", memberInfo.info); //将购物车数据存储到vuex的store中
          }
        })
      }

      const getLookLog = () => {  //获取我的足迹数据
        proxy.$get('/v3/member/front/productLookLog/list').then(res => {
          if (res.state == 200) {
            looklog.log = res.data.list[0] ? res.data.list[0].productLookLogInfoList.slice(0, 4) : []
            looklogLen.value = res.data.list[0] ? res.data.list[0].productLookLogInfoList.length : 0
          }

        })
      }

      const getCartItem = () => {
        proxy.$get('/v3/business/front/cart/cartList').then(res => {
          if (res.state == 200) {
            cartData.data = res.data ? res.data : []
            cartLen.value = res.data ? res.data.availableCartNum ? res.data.availableCartNum: 0 : 0
          }
        })
      }
      // eslint-disable-next-line no-unused-vars
      const handleDownload = (attachmentId) => {
        download('/v3/member/front/member/oaCreateDoc', { attachmentId })
            .then(response => {
              const blob = response.data;
              const contentDisposition = response.headers['content-disposition'];
              let filename = '委托书.pdf';

              if (contentDisposition) {
                // 提取 filename
                const utf8FilenameMatch = contentDisposition.match(/filename\*=UTF-8''(.+)/i);
                if (utf8FilenameMatch) {
                    filename = decodeURIComponent(utf8FilenameMatch[1]);
                } else {
                  const legacyFilenameMatch = contentDisposition.match(/filename="?([^"]+)"?/i);
                  if (legacyFilenameMatch) {
                    filename = legacyFilenameMatch[1];
                  }
                }
              }

              // 创建下载链接
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = url;
              link.download = filename; // 触发下载
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            })
            .catch(error => {
              console.error('下载失败:', error);
              alert('下载失败，请检查网络或权限');
            });
      };

      const getCollectStore = () => {
        proxy.$get('/v3/member/front/followStore/list').then(res => {
          if (res.state == 200) {
            collectStore.store = res.data.storeList
          }
        })
      }

      const getCollectGoods = () => {
        proxy.$get('/v3/member/front/followProduct/list').then(res => {
          if (res.state == 200) {
            collectGoods.goods = res.data.list
          }
        })
      }

      const getHotReco = () => { //获取热门推荐数据
        let params = {
          queryType: 'cart'
        }
        proxy.$get('/v3/goods/front/goods/recommendList', params).then(res => {
          if (res.state == 200) {
            hotRecom.goods = res.data.list
            // hotRecom.goods.map(item => item.goodsPrice = new Number(item.goodsPrice).toFixed(2))
          }
        })
      }

      const getOrder = () => {//获取订单
        let params = {
          current: 1
        }
        proxy.$get('/v3/business/front/orderInfo/list', params).then(res => {
          if (res.state == 200) {
            order.list = res.data.list
            order.list.map(item => item.totalMoney = new Number(item.totalMoney).toFixed(2))
          }
        })
      }

      const seeOrderDetail = (orderSn) => { //去往订单详情
        let newWin = router.resolve({
          path: 'order/detail',
          query: {
            orderSn: orderSn
          }
        })
        window.open(newWin.href, '_blank');
      }

      const toProductDetail = (productId) => {
        let newWin = router.resolve({
          path: '/goods/detail',
          query: {
            productId: productId
          }
        })
        window.open(newWin.href, '_blank');
      }

      const getBalanceinfo = () => {//获取余额信息
        proxy
          .$post("v3/business/front/orderOperate/getDisBalance")
          .then(res => {
            if (res.state == 200) {
              balance_info.value = res.data
            } else {
              ElMessage(res.msg);
            }
          })
          .catch(() => {
            //异常处理
          });
      };
       const gettouxiang = () =>{
        proxy
          .$post("/v3/member/front/member/getGrade")
          .then(res => {
            if (res.state == 200) {
              grade.data = res.data
            }
          })
          .catch(() => {
            //异常处理
          });
      }

      const mergePay = () => {
        router.push('/member/order/mergePay');
      }

      // 显示门店列表弹窗
      const showMemberList = () => {
        storeListVisible.value = true;
        getStoreList();
      };

      // 获取门店列表数据
      const getStoreList = () => {
        proxy.$get("v3/member/front/member/memberList")
          .then(res => {
            if (res.state == 200) {
              storeList.value = res.data;
            } else {
              ElMessage.error(res.msg);
            }
          })
          .catch(err => {
            console.error("获取门店列表失败:", err);
            ElMessage.error(L['获取门店列表失败']);
          });
      };

      // 关闭门店列表弹窗
      const handleCloseStoreList = (done) => {
        done();
      };

      onMounted(() => {
        getInitInfo()
        getLookLog()
        getHotReco()
        getOrder()
        getCartItem()
        getCollectStore()
        getCollectGoods()
        getBalanceinfo()
        gettouxiang();

      })

      return {
        memberInfo, L, looklog,grade,balance_info, hotRecom, getOrder, order, store, seeOrderDetail, toProductDetail, looklogLen, cartData, cartLen, collectStore, collectGoods, mergePay,
        // 门店列表弹窗相关数据和方法
        storeListVisible,
        storeList,
        showMemberList,
        handleCloseStoreList,
        handleDownload

      }
    }
  }
</script>
<style lang="scss" scoped>
  @import '@/style/member/index.scss';
  @import '@/style/base.scss';

  .user_order_empty {
    padding: 90px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;

    p {
      margin-left: 12px;
      color: #666666;
    }
  }

  .no_footprint {
    height: 73px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
  }
  .gradeLogo_img_index{
    width: 80px;
    height: 80px;
    margin: 10px 88px 10px 10px;
    // position: absolute;
    // top: 78px !important;
    // left: 32px !important;
  }
</style>
